{
    "ManageCustomRoles_Title": "Aggiungere un modello di ruolo personalizzato",
    "ManageCustomRoles_Role_Name": "Nome del modello di ruolo",
    "ManageCustomRoles_Description": "Descrizione",
    "ManageCustomRoles_Cancel": "Annullamento",
    "ManageCustomRoles_Help": "Aiuto",
    "ManageCustomRoles_Save": "Risparmiare",
    "NAME": "ManageCustomRoles"
}